var trixSavedRange = null;

$(document).on('trix-blur', 'trix-editor', function () {
  trixSavedRange = this.editor.getSelectedRange();
});

$(document).on('click', '.trix-variable', function (e) {
  e.preventDefault();
  var variable = $(this).data('var');
  var trixEditor = document.querySelector('trix-editor');
  if (trixEditor) {
    trixEditor.focus();
    if (trixSavedRange) {
      trixEditor.editor.setSelectedRange(trixSavedRange);
    }
    trixEditor.editor.insertString(variable);
  }
});
